import NavigationBarControl from '../../../lib/ui/NavigationBarControl'

export default class Sync {
  constructor (element) {
    let fragment = document.createDocumentFragment()
    new NavigationBarControl(fragment, {
      title: 'Synchroniseren'
    })

    let div = document.createElement('div')
    div.className = 'viewport'
   
    let p = document.createElement('p')
    p.innerHTML = 'Een ogenblik geduld alstublieft. Uw apparaat synchroniseert uw laatste gegevens, dit kan enkele seconden duren...'
   
    window.PRIM.bootMessage = document.createElement('p')

    div.appendChild(p)
    div.appendChild(window.PRIM.bootMessage)
    fragment.appendChild(div)        

    element.appendChild(fragment)
    
    window.PRIM.initExternalStorage()
  }
}



// WEBPACK FOOTER //
// ./js/modules/start/action/Sync.js